module.exports = __webpack_public_path__ + "images/63d3c626987968c05ccf79062f8bbe279.svg";